module.exports = __webpack_public_path__ + "static/media/users.b0949ac2.png";